import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Aero design tokens (:root custom properties) — loaded globally so every
// page that references var(--aero-*) resolves them regardless of route.
import './styles/aero-design-system.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';
import i18n from './i18n';
import { I18nextProvider } from "react-i18next";
import {HelmetProvider} from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Analytics />
        <HelmetProvider>
         <App />
        </HelmetProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
